import axios from 'axios';
import { config_headers, servicelist, URL_API } from '../Config';

export const P303GetDataListA= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.PerformanceService}p_performance_summary_list`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P303GetDataListB= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.PerformanceService}p_performance_contract_list`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P303GetDataListC= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.PerformanceService}p_performance_request_no`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}



